import { Box, Flex, Grid, GridItem, Text, Image, Avatar, Divider, FormControl, RadioGroup, Radio, Modal, ModalOverlay, ModalBody, useDisclosure, ModalContent, ModalHeader, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Tooltip, Center, Spinner, ModalCloseButton, Button, IconButton } from "@chakra-ui/react";
import MyDiv from "./CandidateDetails.style";
import { AlertCard, CustomButton, CustomToast } from "../../../../components";
import { useEffect, useState } from "react";
import ArrowRight from "../../../../assets/images/ArrowIcon.svg";
import Lottie from "lottie-react";
import SuccessAnimation from "../../../../assets/lottie/Success.json";
import * as routesNames from "../../../../constants/routes";
import { LOICard, HoldCard, RejectedCard } from "../components";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { baseUrl, useFetch } from "../../../../hooks/useFetch";
import { Controller, Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Dropdown } from "../../../../components/DropDown/DropDown";
import { HrlenseInput } from "../../../../components/Input/Input";
import { IInterviewStatus, statusSchema, emptyInterviewStatus } from "./modal";
import { useAuth } from "../../../../hooks/useAuth";
import MultiSelectTypeahead from "../../../../components/AutoCompleteInput/MultiSelectTypeahead";
import DummyPerson from "../../../../assets/images/DummyPerson.svg"
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { format } from "date-fns/format";
import { AddIcon, MinusIcon, RepeatIcon } from "@chakra-ui/icons";

export const CandidateDetails = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isLoiOpen, onOpen: onLoiOpen, onClose: onLoiClose } = useDisclosure();
  const { isOpen: isRejectedOpen, onOpen: onRejectedOpen, onClose: onRejectedClose } = useDisclosure();
  const { isOpen: isHoldOpen, onOpen: onHoldOpen, onClose: onHoldedClose } = useDisclosure();
  const { isOpen: isInviteOpen, onOpen: onInviteOpen, onClose: onInviteClose } = useDisclosure();
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const { loginObj } = useAuth();
  const [isScheduled, setIsScheduled] = useState(false);
  const [isReschedule, setIsReschedule] = useState(false);
  const [interviewersOptions, setInterviewersOptions] = useState<any[]>([]);
  const [candidateDetails, setCandidateDetails] = useState<any>(null);
  const [statusOptions, setStatusOptions] = useState<any[]>([]);
  const [interviewResultOptions, setInterviewResultOptions] = useState<any[]>([]);
  const [interviewResult, setInterviewResult] = useState<number>(0);
  const [resumeUrl, setResumeUrl] = useState<string>();
  const [pendingforFeedbackAlert, setPendingforFeedbackAlert] = useState(false);
  const [hasUserChanged, setHasUserChanged] = useState(false);
  const [statusDisable, setStatusDisable] = useState(false);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [zoom, setZoom] = useState(1)
  const [resumeLoading, setResumeLoading] = useState(false);
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [avatarUrl, setAvatarUrl] = useState<string | null>(null);
  const { candidate_Id, candidate_Name, job_Profile } = location.state || {};
  const rawJobId = location?.state?.jobId ?? searchParams.get("jobId");
  const jobId = rawJobId && rawJobId !== "undefined" ? rawJobId : null;

  const { handleSubmit, control, formState: { errors }, reset, watch, setValue } = useForm<IInterviewStatus>({
    resolver: yupResolver(statusSchema) as Resolver<IInterviewStatus>,
    defaultValues: emptyInterviewStatus,
    mode: "onBlur",
  });

  const meeting_Type = watch("meeting_Type");
  const interview_Result = watch("interview_Result");

  useEffect(() => {
    if (!hasUserChanged) return; // prevent auto-open on load

    if (interview_Result === 5) {
      onRejectedOpen();
      setInterviewResult(interview_Result);
    } else if (interview_Result === 6) {
      setPendingforFeedbackAlert(true);
      setInterviewResult(interview_Result);
    } else if (interview_Result === 7) {
      onHoldOpen();
      setInterviewResult(interview_Result);
    } else if (interview_Result === 8) {
      onLoiOpen();
      setInterviewResult(interview_Result);
    }
  }, [interview_Result, onRejectedOpen, onHoldOpen, onLoiOpen]);

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "interview_Result" && type === "change") {
        setHasUserChanged(true);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const confirmPendingForFeedback = async () => {
    let payLoad = {
      candidate_Id: candidateDetails?.id,
      interview_Result: 6
    }
    const response = await fetchApi("Candidate/interviewStatusChange", "POST", payLoad, "", "");
    if (response) {
      addToast({ message: `${candidateDetails?.candidate_Name} has been marked as pending for feedback.`, status: "warning" });
      loadCandidateDetail();
      setPendingforFeedbackAlert(false);
    }
  }

  const candidateInfo = [
    { label: "Job Title", value: candidateDetails?.job_profile_Name },
    { label: "Current Location", value: candidateDetails?.current_Location },
    { label: "Experience", value: candidateDetails?.experience === 0 ? "Fresher" : `${candidateDetails?.experience} months` },
    { label: "Current Salary", value: candidateDetails?.current_Salary === 0 ? "-" : candidateDetails?.current_Salary },
    { label: "Expected Salary", value: candidateDetails?.expected_Salary === 0 ? "-" : candidateDetails?.expected_Salary },
    { label: "Preferred Work Mode", value: candidateDetails?.preffered_Work_Mode || "-" },
  ];


  const onSubmit = async (data: IInterviewStatus) => {
    setInviteLoading(true);
    try {
      const payload = {
        candidate_Id,
        status: data.status,
        interview_Date: data.interview_Date,
        interview_Time: data.interview_Time,
        meeting_Type: data.meeting_Type,
        meeting_Link: data.meeting_Link,
        candidate_Subject: data.candidate_Subject,
        interviewer_Subject: data.interviewer_Subject,
        interviewer_Email_Body: data.interviewer_Email_Body,
        candidate_Email_Body: data.candidate_Email_Body,
        interviewer: data.interviewer.map((i) => ({
          employeeID: i.employeeID,
        })),
      };
      const response = await fetchApi("Candidate/scheduleInterview", "POST", payload, "", "");
      if (response) {
        addToast({ message: response.message, status: "success" });
        setIsScheduled(true);
        setIsReschedule(false);
        loadCandidateDetail();
        onOpen();
        onInviteClose();
        setInviteLoading(false);
      }
      setInviteLoading(false);
    } catch (error) {
      addToast({ message: "Something went wrong!", status: "error" });
    }
  };

  const loadResume = async () => {
    try {
      setResumeLoading(true);
      const response = await fetch(`${baseUrl}Candidate/resume?candidate_Id=${candidate_Id}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${loginObj?.token || ""}`,
        },
      });

      if (!response.ok) {
        addToast({ message: "Resume not found", status: "error" });
        return;
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setResumeUrl(url);
    } catch (err) {
      console.error(err);
      setResumeUrl(undefined);
    } finally {
      setResumeLoading(false);
    }
  }

  const getDefaultEmailContent = (candidateName: string, jobProfile: string, interviewDate?: string, interviewTime?: string, meetingType?: string, meetingLink?: string) => {
    return {
      interviewer_Subject: `Interview Scheduled with ${candidateName} - ${jobProfile}`,
      interviewer_Email_Body: `
      Hi Sir/Mam,<br/><br/>
      You have been scheduled to interview <b>${candidateName}</b> for the position of <b>${jobProfile}</b>.<br/><br/>
      <b>Date:</b> ${interviewDate || "[Select Date]"} <br/>
      <b>Time:</b> ${interviewTime || "[Select Time]"} <br/>
      <b>Mode:</b> ${meetingType || "[Virtual/Face-to-Face]"} <br/>
      ${meetingType === "virtual" ? `<b>Meeting Link:</b> ${meetingLink || "[Add Link]"}` : ""}
      <br/><br/>
      Please be on time and let us know if you face any issues.<br/><br/>
      Thanks,<br/>
      HR Team
    `,

      candidate_Subject: `Interview Invitation for ${jobProfile}`,
      candidate_Email_Body: `
      Hi ${candidateName},<br/><br/>
      We are pleased to invite you for an interview for the role of <b>${jobProfile}</b>.<br/><br/>
      <b>Date:</b> ${interviewDate || "[Select Date]"} <br/>
      <b>Time:</b> ${interviewTime || "[Select Time]"} <br/>
      <b>Mode:</b> ${meetingType || "[Virtual/Face-to-Face]"} <br/>
      ${meetingType === "virtual" ? `<b>Meeting Link:</b> ${meetingLink || "[Add Link]"}` : ""}
      <br/><br/>
      Please confirm your availability by replying to this email.<br/><br/>
      Best regards,<br/>
      HR Team
    `,
    };
  };

  const handleOpenInvite = () => {
    const interviewers = watch("interviewer");
    const interviewDate = watch("interview_Date");
    const interviewTime = watch("interview_Time");
    const meetingType = watch("meeting_Type");
    const meetingLink = watch("meeting_Link");

    // Validate Interviewers
    if (!interviewers || interviewers.length === 0) {
      addToast({ message: "Please select at least one interviewer.", status: "error" });
      return;
    }

    // Validate Date & Time
    if (!interviewDate) {
      addToast({ message: "Please select interview date.", status: "error" });
      return;
    }
    if (!interviewTime) {
      addToast({ message: "Please select interview time.", status: "error" });
      return;
    }

    // Validate Meeting Type
    if (!meetingType) {
      addToast({ message: "Please select meeting mode (Virtual/Face-to-Face).", status: "error" });
      return;
    }

    // If virtual, validate meeting link
    if (meetingType === "virtual") {
      const urlPattern = /^(https?:\/\/[^\s]+)$/; // simple URL check
      if (!meetingLink || !urlPattern.test(meetingLink)) {
        addToast({ message: "Please enter a valid meeting link.", status: "error" });
        return;
      }
    }

    // If everything is valid → set default email content and open modal
    const defaults = getDefaultEmailContent(
      candidateDetails?.candidate_Name || "Candidate",
      candidateDetails?.job_profile_Name || "Job Role",
      interviewDate,
      interviewTime,
      meetingType,
      meetingLink
    );

    setValue("interviewer_Subject", defaults.interviewer_Subject);
    setValue("interviewer_Email_Body", defaults.interviewer_Email_Body);
    setValue("candidate_Subject", defaults.candidate_Subject);
    setValue("candidate_Email_Body", defaults.candidate_Email_Body);

    onInviteOpen();
  };



  const loadCandidateDetail = async () => {
    const response = await fetchApi("Candidate/candidateDetails", "GET", "", `candidate_Id=${candidate_Id}`, "");
    if (response) {
      setCandidateDetails(response);

      if (response.status === 2) {
        setValue("status", response.status);
        loadShortListStatus(true);
      } else if (response.status === 5 || response.status === 6 || response.status === 7 || response.status === 8 || response.status === 9 || response.status === 10 || response.status === 12) {
        loadShortListStatus(true);
        setValue("interview_Result", response.status)
        setStatusDisable(true);
        setValue("status", 2);
      } else if (response.status === 9) {
        setValue("status", 2);
        setValue("interview_Result", response.status);
        setStatusDisable(true);
      }
      // used for interviewers 
      if (response.interviewers?.length) {
        setInterviewersOptions((prev) => {
          const ids = new Set(prev.map((i) => i.employeeID));
          const newOnes = response.interviewers.filter((i: { employeeID: number; }) => !ids.has(i.employeeID));
          return [...prev, ...newOnes];
        });
        setValue("interviewer", response.interviewers);
      }

      setValue("interview_Date", response.interview_Date ? format(response.interview_Date, 'yyyy-MM-dd') : '');
      setValue("interview_Time", response.interview_Time || "");
      setValue("meeting_Type", response.meeting_Type || "");
      setValue("meeting_Link", response.meeting_Link || "");
    }

  }

  const loadInterviewers = async (query?: string) => {
    if (!query) {
      setInterviewersOptions([]);
      return;
    }
    const response = await fetchApi("RecruitmentDropDown/interviewerList", "GET", "", `filter=${query}`, "");
    if (response) {
      setInterviewersOptions(response);
    }
  }

  const loadShortListStatus = async (interviewResultOption?: boolean) => {
    const response = await fetchApi("RecruitmentDropDown/getRecStatus", "GET", "", `shortlistOption=${true}&interviewOption=${interviewResultOption ?? false}`, "");
    if (response) {
      setStatusOptions(response.shortlisted);
      setInterviewResultOptions(response.interviewResult || []);
    }
  }

  useEffect(() => {
    if (!candidateDetails?.employee_Id) return;

    const fetchAvatar = async () => {
      try {
        const res = await fetch(`${baseUrl}Hrlense_Employee/profilepic/${candidateDetails?.employee_Id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${loginObj?.token || ""}`,
          },
        });

        if (!res.ok) throw new Error("Avatar not found");



        const blob = await res.blob();
        if (blob.size > 0) {
          setAvatarUrl(URL.createObjectURL(blob));
        } else {
          setAvatarUrl(null);
        }
      } catch (err) {
        console.error("Error fetching avatar", err);
        setAvatarUrl(null);
      }
    };

    fetchAvatar();
  }, [candidateDetails?.employee_Id]);

  useEffect(() => {
    loadCandidateDetail();
    loadShortListStatus();
    loadResume();
  }, [reload])

  return (
    <MyDiv>
      <Box className="page_wrapper ">
        <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
          <BreadcrumbItem>
            <BreadcrumbLink className="font_poppins text_md text_medium" href={routesNames.ACTIVEJOBS} color="gray.500">Job Openings</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <BreadcrumbLink as={Link} to={jobId ? `${routesNames.CANDIDATELIST}?jobId=${jobId}` : routesNames.CANDIDATELIST} className="font_poppins text_md text_medium" color="gray.500"> {job_Profile} </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink className="font_poppins text_md text_medium" href='#'>{candidate_Name}</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
        <Grid className="grid_container" gap={4} mt={4}>
          {/* Candidate Details */}
          <GridItem colSpan={5} mt={4}>
            <Box className="card">
              <Box display="flex">
                <Avatar className="Avatar" src={avatarUrl || DummyPerson} name={candidate_Name} size="xl" />
                <Box className="employee-info" pl={16} lineHeight={2}>
                  <Text className="font-poppins text_medium text_lg">{candidateDetails?.candidate_Name}</Text>
                  <Text className="font-poppins text_medium text_lg">Email : <Tooltip label={candidateDetails?.email} hasArrow><Text as={"span"} className="font-poppins text_md text_md" maxWidth="18vw" isTruncated display="inline-block" verticalAlign="bottom">{candidateDetails?.email}</Text></Tooltip></Text>
                  <Text className="font-poppins text_medium text_lg">Mobile : <Text as={"span"} className="font-poppins text_md text_md">{candidateDetails?.phone}</Text></Text>
                </Box>
              </Box>
            </Box>
            {/*------------- Candidate Info ---------------*/}
            <Box className="info" mt={1}>
              <Text className="font-poppins text_medium text_xl" mb={3}>Candidate Information</Text>
              {candidateInfo.map((item, index) => (
                <Box key={index} p={2}>
                  <Flex justifyContent="space-between">
                    <Text className="font-poppins text_lg text_medium">{item.label}</Text>
                    <Text className="font-poppins text_regular text_md">{item.value}</Text>
                  </Flex>
                  {index !== candidateInfo.length - 1 && <Divider />}
                </Box>
              ))}
            </Box>

            {/*----- Candidate Status------------ */}
            <Flex justifyContent="space-between" py={5} gap={20}>
              {/* Always show Status dropdown */}
              <Dropdown
                isRequired
                disable={statusDisable}
                label="Status"
                control={control}
                placeholder="Select Status"
                options={statusOptions}
                name="status"
                errors={errors}
                valueKey="id"
                labelKey="status"
              />

              {/* If status is NOT 9, 10, 12 → show Interview Result dropdown */}
              {![9, 10, 12].includes(candidateDetails?.status) && interviewResultOptions.length > 0 && (
                <Dropdown
                  isRequired={false}
                  label="Interview Result"
                  control={control}
                  placeholder="Select Interview Result"
                  options={interviewResultOptions}
                  name="interview_Result"
                  errors={errors}
                  valueKey="id"
                  labelKey="status"
                />
              )}

              {/* If status is 9, 10, 12 → show text instead */}

              {[9, 10, 12].includes(candidateDetails?.status) && (
                <Box mt={8} ml={3}>
                  <Text
                    className="font-poppins text_lg text_medium"
                    color={
                      candidateDetails?.status === 5 || candidateDetails?.status === 10
                        ? "red.500"
                        : "green.500"
                    }
                  >
                    {candidateDetails?.status_Name}
                  </Text>
                </Box>
              )}

            </Flex>
            {/*------------------ Schedule Interview ------------------*/}
            <Box className="card" mt={1} pointerEvents={statusDisable ? "none" : "auto"} opacity={statusDisable ? 0.6 : 1} >
              <Box p={3} >
                <Text fontWeight="semibold" mb={2}>Schedule Interview</Text>
                <FormControl mb={3}>
                  <FormControl mb={3} isRequired>
                    <Text fontWeight="semibold" mb={2}>Interviewers</Text>
                    <MultiSelectTypeahead disabled={statusDisable} name="interviewer" control={control} options={interviewersOptions} onCompletion={(query) => { loadInterviewers(query); }} loading={false} optionValue="employeeID" optionLabel="interviewer_Name" placeholder="Search interviewer..." />
                    {errors.interviewer && (
                      <Text fontSize="sm" color="red.500"> {errors.interviewer.message}</Text>
                    )}
                  </FormControl>
                </FormControl>
                <Flex gap={2}>
                  <HrlenseInput readOnly={statusDisable} disable={statusDisable} isRequired type="date" name="interview_Date" label="Interview Date" control={control} placeholder="Select interview Date" />
                  <HrlenseInput readOnly={statusDisable} disable={statusDisable} isRequired type="time" name="interview_Time" label="Interview Time" control={control} placeholder="Select interview Time" />
                </Flex>
                <FormControl mb={3} mt={4} isRequired>
                  <Flex justify="space-between">
                    <Text className="font-poppins text_lg text_regular" mb={1}>Mode <span color="red.500">*</span></Text>
                    <Controller name="meeting_Type" control={control} rules={{ required: "Meeting type is required" }} render={({ field }) => (
                      <RadioGroup {...field} isDisabled={statusDisable}>
                        <Flex gap={4}>
                          <Radio value="virtual" className="font-poppins text_regular text_lg"  > Virtual </Radio>
                          <Radio value="face-to-face" className="font-poppins text_regular text_lg" > Face to Face </Radio>
                        </Flex>
                      </RadioGroup>
                    )}
                    />
                  </Flex>
                  {errors.meeting_Type && (<Text fontSize="sm" color="red.500"> {errors.meeting_Type.message} </Text>)}
                </FormControl>
                {meeting_Type === "virtual" && (
                  <HrlenseInput disable={statusDisable} type="text" name="meeting_Link" label="Meeting Link" control={control} placeholder="Enter Meeting Link" />
                )}
                <Flex justify="flex-end" mt={4}>
                  <CustomButton title={candidateDetails?.status === 2 ? "Re-Schedule" : "Send Invite"} className="btn font-poppins text_sm text_medium" rightIcon={<Image src={ArrowRight} />} onClick={handleOpenInvite} isDisabled={!watch("status") || statusDisable} />
                </Flex>
              </Box>
            </Box>
          </GridItem>

          {/*------------ Candidate Resume -----------------*/}
          <GridItem colSpan={7}>
            <Flex className="page_heading flex_header" justify="space-between" align="center">
              <Text className="font-poppins text_medium text_xxl" mt={4}>Candidate Resume</Text>

              {!resumeLoading && resumeUrl && (
                <Flex align="center" gap={2} mt={4}>
                  <IconButton aria-label="Zoom out" icon={<MinusIcon />} size="sm" variant="outline" onClick={() => setZoom(prev => Math.max(0.5, parseFloat((prev - 0.1).toFixed(1))))} isDisabled={zoom <= 0.5} />
                  <Text className="font-poppins text_md" minW="45px" textAlign="center"> {Math.round(zoom * 100)}% </Text>
                  <IconButton aria-label="Zoom in" icon={<AddIcon />} size="sm" variant="outline" onClick={() => setZoom(prev => Math.min(2, parseFloat((prev + 0.1).toFixed(1))))} isDisabled={zoom >= 2} />
                  <IconButton aria-label="Reset zoom" icon={<RepeatIcon />} size="sm" variant="ghost" onClick={() => setZoom(1)} />
                </Flex>
              )}
            </Flex>
            <Box h="800px" position="relative" overflow="hidden" borderRadius="md">
              {resumeLoading ? (
                <Center position="absolute" top={0} left={0} right={0} bottom={0} bg="whiteAlpha.700">
                  <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                </Center>
              ) : resumeUrl ? (
                <Box w="100%" h="100%" display="flex" alignItems="center" justifyContent="center" overflow="hidden">
                  <Box
                    style={{ width: "100%", height: "100%", transform: `scale(${zoom})`, transformOrigin: "center center", transition: "transform 0.2s ease", }} >
                    <iframe src={`${resumeUrl}#toolbar=0&navpanes=0&scrollbar=0`} width="100%" height="100%" style={{ border: "none", display: "block" }} title="Candidate Resume" />
                  </Box>
                </Box>
              ) : (
                <Flex h="100%" justify="center" align="center" border="1px dashed #ccc" borderRadius="md">
                  <Text className="font-poppins text_md text_medium" color="gray.500"> Candidate Resume Not Available </Text>
                </Flex>
              )}
            </Box>
          </GridItem>
        </Grid>
      </Box>

      {/* -----------------LOI Send Modal Component -----------------*/}

      <Modal isOpen={isLoiOpen} onClose={onLoiClose} size="5xl" isCentered>
        <ModalOverlay />
        <ModalContent p={1} borderRadius="xl">
          <LOICard onClose={onLoiClose} candidateDetail={candidateDetails} interviewResult={interviewResult} reload={reload} setReload={setReload} />
        </ModalContent>
      </Modal>

      {/* ----- Rejected Modal ----- */}
      <Modal isOpen={isRejectedOpen} onClose={onRejectedClose} size="2xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={4}>
          <RejectedCard onClose={onRejectedClose} candidateDetail={candidateDetails} interviewResult={interviewResult} reload={reload} setReload={setReload} />
        </ModalContent>
      </Modal>

      {/* ----- Hold Modal ----- */}
      <Modal isOpen={isHoldOpen} onClose={onHoldedClose} size="2xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={4}>
          <HoldCard onClose={onHoldedClose} candidateDetail={candidateDetails} interviewResult={interviewResult} reload={reload} setReload={setReload} />
        </ModalContent>
      </Modal>

      {/* ----- Send Invite Email  Modal ----- */}
      <Modal isOpen={isInviteOpen} onClose={onInviteClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={4}>
          <ModalHeader textAlign="center" className="font-poppins text_medium text_xl">Send Interview Invite</ModalHeader>
          <ModalCloseButton />
          <Divider />
          <ModalBody>
            <Grid templateColumns="repeat(2, 1fr)" gap={8}>
              <Box>
                <FormControl mb={4} isRequired>
                  <HrlenseInput type="text" name="interviewer_Subject" control={control} label="Interviewer Subject" placeholder="Enter interviewer email subject" />
                </FormControl>
                <FormControl mb={6} isRequired>
                  <Text className="font-poppins text_md text_medium" mb={1}>Interviewer Email</Text>
                  <Controller
                    name="interviewer_Email_Body"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <SunEditor
                        height="350px"
                        placeholder="Write interviewer email content..."
                        setContents={value || ""}   // pre-fill works
                        setOptions={{
                          buttonList: [
                            ["undo", "redo"],
                            ["bold", "italic", "underline"],
                            ["fontColor", "hiliteColor"],
                            ["align", "list"],
                            ["link"],
                            ["fullScreen"],
                          ],
                        }}
                        onChange={(content) => onChange(content)} // update form state
                      />
                    )}
                  />
                </FormControl>
              </Box>

              <Box>
                <FormControl mb={4} isRequired>
                  <HrlenseInput type="text" name="candidate_Subject" control={control} label="Candidate Subject" placeholder="Enter candidate email subject" />
                </FormControl>

                <FormControl mb={6} isRequired>
                  <Text className="font-poppins text_md text_medium" mb={1}>Candidate Email</Text>
                  <Controller
                    name="candidate_Email_Body"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                      <SunEditor
                        height="350px"
                        placeholder="Write candidate email content..."
                        setContents={value || ""}   // pre-fill works
                        setOptions={{
                          buttonList: [
                            ["undo", "redo"],
                            ["bold", "italic", "underline"],
                            ["fontColor", "hiliteColor"],
                            ["align", "list"],
                            ["link"],
                            ["fullScreen"],
                          ],
                        }}
                        onChange={(content) => onChange(content)} // update form state
                      />
                    )}
                  />
                </FormControl>
              </Box>
            </Grid>
          </ModalBody>
          <Flex justify="flex-end" gap={3}>
            <Button
              className="font-poppins text_sm text_medium"
              rightIcon={inviteLoading ? undefined : <Image src={ArrowRight} />}
              onClick={handleSubmit(onSubmit)}
              isLoading={inviteLoading}
              loadingText="Sending..."
              style={{ color: "white", backgroundColor: "green" }}
            >
              Send Invite
            </Button>
          </Flex>

        </ModalContent>
      </Modal>

      {/* ----- Pending for Feedback ----- */}
      <AlertCard
        isOpen={pendingforFeedbackAlert}
        onClose={() => { setPendingforFeedbackAlert(false); setInterviewResult(0) }}
        onConfirm={confirmPendingForFeedback}
        title={`Mark ${candidateDetails?.candidate_Name} as Pending for Feedback`}
        description="Are you sure you want to mark this candidate as pending for feedback?"
        confirmLabel="Confirm"
        cancelLabel="Cancel"
        colorScheme="green"
      />


      {/* -----------------Success Modal---------------- */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered size="sm">
        <ModalOverlay />
        <ModalContent borderRadius="lg" p={4}>
          <ModalHeader textAlign="center" className="font-poppins text_medium text_xxl">{isReschedule ? "Interview Re-Scheduled" : "Interview Scheduled"}</ModalHeader>
          <Divider />
          <ModalBody>
            <Box textAlign="center" p={1}>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Lottie animationData={SuccessAnimation} loop={false} style={{ height: 120 }} />
              </Box>
              <Text mt={2} className="font-poppins text_sm text_semibold" color="green.600">{isReschedule ? "Interview Re-Scheduled Successfully" : "Interview Scheduled Successfully"}</Text>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </MyDiv>
  );
};

export default CandidateDetails;
